import * as Sentry from "@sentry/react";

// Personalized payment links and Checkout returns stay outside session replay.
const paymentPath=(window as Window&{__isAutopayPath?:(path:string)=>boolean}).__isAutopayPath;
let privatePaymentPage=paymentPath?.(window.location.pathname)??false;
if(!paymentPath){try{privatePaymentPage=/^\/automaticke-platby\/?$/i.test(decodeURIComponent(window.location.pathname));}catch{privatePaymentPage=false;}}
const privateOrderPage=()=>{try{return /^\/(objednavka|podpis-zmluvy)\/?$/i.test(decodeURIComponent(window.location.pathname));}catch{return false;}};
privatePaymentPage=privatePaymentPage||privateOrderPage();
if (!privatePaymentPage) Sentry.init({
  dsn: "https://676c6529ec9c428bcd738528df5012f3@o4511804990488576.ingest.de.sentry.io/4511805016899664",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
  beforeSend:event=>privateOrderPage()?null:event,
  beforeSendTransaction:event=>privateOrderPage()?null:event,
});
